export default __webpack_public_path__ + "static/media/operative.67a1aa74.svg";